/**
 * Session Provider Component
 * Initializes session management for the entire app
 * - Monitors token expiration
 * - Handles automatic refresh
 * - Shows session warnings
 */

import { useSessionManager } from '@/hooks/use-session-manager';
import { useAuthStore } from '@/store/auth-store';
import { useEffect } from 'react';

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  const { remainingTime } = useSessionManager();

  // Log session status in development
  useEffect(() => {
    if (import.meta.env.DEV && isAuthenticated && remainingTime) {
      const minutes = Math.floor(remainingTime / 1000 / 60);
      console.log(`[Session] Time remaining: ${minutes} minutes`);
    }
  }, [isAuthenticated, remainingTime]);

  return <>{children}</>;
}
